import {Route, Switch, useParams} from 'react-router-dom';
import {useSelector} from 'react-redux';
import React, {useEffect} from 'react';

const EventLanguage = props => {
    const {eventId} = useParams(),
        eventLanguage = useSelector(state => state.events[eventId]?.event.language || state.session.user?.language_code) || 'en',
        currentLocale = useSelector(state => state.i18n.locale);

    useEffect(() => {
        if (currentLocale != eventLanguage) {
            app.store.dispatch(app.actions.i18n.loadLanguage(eventLanguage));
        }
    }, [eventLanguage]);

    // this component has no UI meaning
    return null;
};

const UserPrefLanguage = props => {
    const language_code = useSelector(state => state.session.user?.language_code || state.session.prefill?.summary?.language),
        currentLocale = useSelector(state => state.i18n.locale);

    useEffect(() => {
        if (language_code && language_code != currentLocale) {
            app.store.dispatch(app.actions.i18n.loadLanguage(language_code));
        }
    }, [language_code]);

    // this component has no UI meaning
    return null;
};

const I18nSwitcher = props => (
    <Switch>
        <Route path="/events/:eventId" component={EventLanguage} />
        <Route path="" component={UserPrefLanguage} />
    </Switch>
);

export default I18nSwitcher;
